/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WhatsAppIntegrationPolicyResponse } from '../models/WhatsAppIntegrationPolicyResponse';
import type { WhatsAppIntegrationPolicyUpdateBody } from '../models/WhatsAppIntegrationPolicyUpdateBody';
import type { WhatsAppOnboardingConfigurationResponse } from '../models/WhatsAppOnboardingConfigurationResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MessagingWhatsappIntegrationPolicyService {
    /**
     * Returns the tenant policy to authorized billing administrators.
     * @returns WhatsAppIntegrationPolicyResponse Ok
     * @throws ApiError
     */
    public static getIntegrationPolicy(): CancelablePromise<WhatsAppIntegrationPolicyResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/messaging/whatsapp/integration-policy',
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Policy revision conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Updates the policy applied only to future WhatsApp signup attempts.
     * @param requestBody
     * @returns WhatsAppIntegrationPolicyResponse Ok
     * @throws ApiError
     */
    public static updateIntegrationPolicy(
        requestBody: WhatsAppIntegrationPolicyUpdateBody,
    ): CancelablePromise<WhatsAppIntegrationPolicyResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/messaging/whatsapp/integration-policy',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Policy revision conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Creates the durable policy snapshot required before Embedded Signup.
     * @returns WhatsAppOnboardingConfigurationResponse Ok
     * @throws ApiError
     */
    public static createOnboardingConfiguration(): CancelablePromise<WhatsAppOnboardingConfigurationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/messaging/whatsapp/onboarding-configuration',
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Policy revision conflict`,
                500: `Internal Server Error`,
            },
        });
    }
}
